<template>
  <div class="row">
    <div class="col-12">
      <q-form ref="editForm">
        <c-card title="대상공정 상세" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn 
                v-if="editable && isSelect" 
                :isSubmit="isSave"
                :url="saveUrl"
                :param="process"
                mappingType="PUT"
                label="대상공정 저장" 
                icon="save"
                @beforeAction="saveProcess"
                @btnCallback="saveProcessCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <template v-if="checkProcessCd">
                <c-process
                  :editable="editable"
                  :disabled="true"
                  label="단위공정"
                  name="processCd"
                  v-model="process.processCd">
                </c-process>
              </template>
              <template v-else>
                <c-text
                  :editable="editable"
                  :disabled="true"
                  label="공정"
                  name="processName"
                  v-model="process.processName">
                </c-text>
              </template>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <c-vendor
                :editable="editable"
                type="edit"
                label="평가업체"
                name="assessDeptCd"
                v-model="process.assessDeptCd">
              </c-vendor>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <c-field 
                isWrite
                :required="true" 
                :editable="editable"
                :disabled="!isSelect" 
                :data="process"
                type="user" 
                userName="assessUserName"
                label="평가담당자" 
                name="assessUserId" 
                v-model="process.assessUserId"
                @username="(name) => { process.assessUserName = name }" />
            </div>
            <div v-if="assessPlan.ramTechniqueCd==='RT00000025'" class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <c-select
                :editable="editable"
                :disabled="!isSelect" 
                codeGroupCd="WORK_CYCLE_CD"
                type="edit"
                itemText="codeName"
                itemValue="code"
                name="workCycleCd"
                label="작업발생주기"
                v-model="process.workCycleCd"
              ></c-select>
            </div>
            <div v-if="assessPlan.ramTechniqueCd==='RT00000025'" class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <c-text
                :editable="editable"
                :disabled="!isSelect" 
                type="number"
                label="작업시간(1회)"
                name="workingTime"
                v-model="process.workingTime">
              </c-text>
            </div>
            <div v-if="assessPlan.ramTechniqueCd==='RT00000030'" class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
              <c-text
                :required="true" 
                :disabled="!isSelect"
                :editable="editable"
                type="number"
                label="사용온도(℃)"
                name="temperature"
                v-model="process.temperature">
              </c-text>
            </div>
            <div class="col-12">
              <c-textarea
                :editable="editable"
                :disabled="!isSelect"
                label="공정특징설명"
                name="processExplainFeature"
                v-model="process.processExplainFeature">
              </c-textarea>
            </div>
          </template>
        </c-card>
        <component
          :is="subComponent"
          :process.sync="process"
          :assessPlan.sync="assessPlan"
          :disabled.sync="disabled"
          :updateBtnData.sync="updateBtnData"
          @saveProcess="emitSaveProcess"
        />
      </q-form>
    </div>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'riskTargetProcessDetail',
  props: {
    assessPlan: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        ramStepCd: '',
        ramTechniqueCd: '',  // 평가기법 코드_HAZOP/KRAS/JSA/CHECKLIST
        processes: [], // 대상공정 목록
      }),
    },
    process: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',  // 평가 일련번호
        processCd: '',  // 단위공정 코드
        processName: '',  // 단위공정명
        ramProcessAssessStepCd: '',  // 평가진행상태
        processExplainFeature: '',  // 공정 특징 설명
        assessDeptCd: '',  // 평가 부서 코드
        assessUserId: '',  // 평가 담당자
        assessUserName: '',  // 평가 담당자
        workCycleCd: null,  // 작업발생주기코드
        workingTime: 0,  // 작업시간(1회)
        vendorFlag: 0,
        temperature: null,
        workMeasurementPlanId: '',
        measPlanContent: '',
        regUserId: '',  // 작성자 ID
        chgUserId: '',  // 수정자 ID
        equipments: [],
        sops: [],
        drawNodes: [],
        draws: [],
        fmScenarios: [],
        hazopScenarios: [],
        scenarios: [],
        charmResultScenarios: [],
        charmEstimationScenarios: [],
        targets: [],
      }),
    },
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    updateBtnData: {
      type: Object,
      default: () => ({
        flag: false,
        research: '',
      }),
    },
  },
  data() {
    return {
      // subComponent: () => import(`${'./4mTargetJobRisk.vue'}`),
      editable: true,
      saveUrl: '',
      isSave: false,
    };
  },
  computed: {
    isSelect() {
      return this.process 
        && this.process.processCd 
        && !this.disabled 
        && this.process.ramProcessAssessStepCd !== 'RPA0000005' ? true : false
    },
    checkProcessCd() {
      return this.process.processCd.indexOf('WTE') === -1
    },
    subComponent() {
      let components = () => import(`${'@/pages/ram/4m/plan/4mTargetJobRisk.vue'}`)
      // if (this.assessPlan.ramTechniqueCd === 'RT00000001') {
      //   // HAZOP
      //   components = () => import(`${'@/pages/ram/hazop/plan/hazopTargetPidNode.vue'}`)
      // } else if (this.assessPlan.ramTechniqueCd === 'RT00000005') {
      //   // K-PSR
      //   components = () => import(`${'@/pages/ram/kpsr/plan/kpsrTargetPidNode.vue'}`)
      // } else if (this.assessPlan.ramTechniqueCd === 'RT00000010') {
      //   // Check-list
      //   components = () => import(`${'@/pages/ram/checklist/plan/checklistTarget.vue'}`)
      // } else if (this.assessPlan.ramTechniqueCd === 'RT00000015') {
      //   // JRA
      //   components = () => import(`${'@/pages/ram/jsa/plan/jsaTargetJobRisk.vue'}`)
      // } else if (this.assessPlan.ramTechniqueCd === 'RT00000020') {
      //   // KRAS
      //   components = () => import(`${'@/pages/ram/kras/plan/krasTargetJobRisk.vue'}`)
      // } else if (this.assessPlan.ramTechniqueCd === 'RT00000025') {
      //   // 4M
      //   components = () => import(`${'@/pages/ram/4m/plan/4mTargetJobRisk.vue'}`)
      // } else if (this.assessPlan.ramTechniqueCd === 'RT00000030') {
      //   // CHARM
      //   components = () => import(`${'@/pages/ram/charm/plan/charmTargetChem.vue'}`)
      // }
      return components;
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.ram.assessProcess.update.url
      // code setting
      // list setting
    },
    emitSaveProcess(processCd) {
      this.$emit('saveProcess', processCd)
    },
    removeEquipment(item) {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '제외하시겠습니까? ',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.process.equipments = this.$_.reject(this.process.equipments, item)
        },
        // 취소 callback 함수
        cancelCallback: () => {
          item.check = true
        },
      });
    },
    saveProcess() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.process.chgUserId = this.$store.getters.user.userId

              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveProcessCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('saveProcess', this.process.processCd)
    },
  }
};
</script>
